@if (isEnableSignatureMembership) {
  <div>
    @if (membership.silver) {
      <span>
        @if (shouldDisplayIcon) {
          <img
            alt="silver"
            title="Silver status"
            src="https://www.cfacdn.com/img/Spotlight/Icons/SilverTierIcon.png"
            [ngClass]="shouldDisplayIcon && !shouldDisplayLabel ? 'member-status__silver-mobile-icon' : 'member-status__silver-icon'"/>
        }
        @if (shouldDisplayLabel) {
          <span [ngClass]="{'member-status__label': shouldDisplayIcon && shouldDisplayLabel}">
            Silver @if (shouldDisplayMemberText) {
            <span>Member</span>
          }
        </span>
      }
    </span>
  }
  @if (membership.red) {
    <span>
      @if (shouldDisplayIcon) {
        <img
          alt="red"
          title="Red status"
          src="https://www.cfacdn.com/img/Spotlight/Icons/RedTierIcon.png"
          [ngClass]="shouldDisplayIcon && !shouldDisplayLabel ? 'member-status__red-icon-mobile' : 'member-status__red-icon'"/>
      }
      @if (shouldDisplayLabel) {
        <span [ngClass]="{'member-status__label': shouldDisplayIcon && shouldDisplayLabel}">
          Red @if (shouldDisplayMemberText) {
          <span>Member</span>
        }
      </span>
    }
  </span>
}
@if (membership.justCfaOne && displayCfaOne) {
  <span>
    @if (shouldDisplayIcon) {
      <img
        alt="Chick-fil-A one"
        title="Chick-fil-A One status"
        src="https://www.cfacdn.com/img/Spotlight/Icons/OneTierIcon.png"
        [ngClass]="shouldDisplayIcon && !shouldDisplayLabel ? 'member-status__cfa-one-mobile-icon' : 'member-status__cfa-one-icon'"/>
    }
    @if (shouldDisplayLabel) {
      <span [ngClass]="{'member-status__label': shouldDisplayIcon && shouldDisplayLabel}">
        One @if (shouldDisplayMemberText) {
        <span>Member</span>
      }
    </span>
  }
</span>
}
@if (membership.signature) {
  <span>
    @if (shouldDisplayIcon) {
      <img
        alt="signature"
        title="Chick-fil-A One status"
        src="https://www.cfacdn.com/img/Spotlight/Icons/SignatureIcon2.png"
        [ngClass]="shouldDisplayIcon && !shouldDisplayLabel ? 'member-status__signature-icon-mobile' : 'member-status__signature-icon'"/>
    }
    @if (shouldDisplayLabel) {
      <span [ngClass]="{'member-status__label': shouldDisplayIcon && shouldDisplayLabel}">
        Signature @if (shouldDisplayMemberText) {
        <span>Member</span>
      }
    </span>
  }
</span>
}
@if (membership.prospect) {
  <span>
    @if (shouldDisplayIcon) {
      <img
        alt="prospect"
        title="Prospect Status"
        src="../../../../assets/img/non-cfa-one-member.svg"
        [ngClass]="shouldDisplayIcon && !shouldDisplayLabel ? 'member-status__cfa-one-mobile-icon' : 'member-status__icon'"/>
    }
  </span>
}
</div>
}
@if (!isEnableSignatureMembership) {
  <div>
    @if (membership.silver) {
      <img alt="silver"
        title="Silver status"
        src="../../../../assets/img/silver_tier.svg"
        [ngClass]="isMobile ? 'member-status__mobile-icon' : 'member-status__icon'"/>
    }
    @if (membership.red) {
      <img alt="red"
        title="Red status"
        src="../../../../assets/img/red_tier.svg"
        [ngClass]="isMobile ? 'member-status__mobile-icon' : 'member-status__icon'"/>
    }
    @if (membership.justCfaOne && displayCfaOne) {
      <img alt="Chick-fil-A one"
        title="Chick-fil-A One status"
        src="../../../../assets/img/cfa-one-icon.svg"
        [ngClass]="isMobile ? 'member-status__mobile-icon' : 'member-status__icon'"/>
    }
    @if (membership.prospect) {
      <img alt="prospect"
        title="Prospect Status"
        src="../../../../assets/img/non-cfa-one-member.svg"
        [ngClass]="isMobile ? 'member-status__mobile-icon' : 'member-status__icon'"/>
    }
    @if (membership.signature) {
      <img alt="signature"
        title="Chick-fil-A One status"
        src="https://www.cfacdn.com/img/Spotlight/Icons/SignatureIcon2.png"
        [ngClass]="isMobile ? 'member-status__mobile-icon' : 'member-status__icon'"/>
    }
  </div>
}
